import React from 'react'
import { createRoot } from 'react-dom/client'
import { client } from './utils'
import { customCss as endpoints } from './api_urls'
import classnames from 'classnames'

export const OBJECT_ID = window.location.pathname.split('/')[3] || ''

class Application extends React.Component {
  constructor() {
    super()
    this.state = {
      templateName: '',
      navBar: '',
      navBarText: '',
      navBarHoverBackground: '',
      navBarHoverText: '',
      navBarLogoPath: '',
      navBarLogoContainerBackground: '',
      navBarLogoContainerTopValue: '',
      navBarLogoContainerLeftValue: '',
      navBarLogoContainerWidthValue: '',
      navBarLogoContainerHeightValue: '',
      navBarLogoWidthValue: '',
      navBarLogoHeightValue: '',
      navBarLogoMarginValue: '',
      titlePageLogoPath: '',
      titlePageBackgroundImagePath: '',
      titlePageBackgroundColor: '',
      level1HeadingBackground: '',
      level1HeadingText: '',
      level2HeadingText: '',
      level3HeadingText: '',
      sectionNavMainColor: '',
      sectionNavHoverText: '',
      bootstrapPrimaryColor: '',
      bootstrapPrimaryHoverColor: '',
      customCss: '',
      customJs: '',
      customCssEdit: false,
      customJsEdit: false,
      submitted: false,
      serverError: false,
      showForm: true,
      formErrors: [],
    }
  }

  componentDidMount() {
    if (OBJECT_ID !== '') {
      let nextState = { formErrors: ['Error getting CSS Template data'] }
      client
        .get(endpoints.show({ id: OBJECT_ID }))
        .then(resp => {
          this.setState(resp.data)
        })
        .catch(e => {
          console.error('Failure getting CSS Template', e)
          this.setState(nextState)
        })
    }
  }
  /**
   * Toggle the visibility of the feedback form
   */
  toggleFormDisplay = () => {
    this.setState(({ showForm }) => ({ showForm: !showForm }))
  }

  /**
   * Toggle the visibility of the feedback form
   */
  resetForm = () => {
    this.setState(({ showForm }) => ({ showForm: !showForm, submitted: false }))
  }

  /**
   * Handle changes from input elements and perform validation
   */
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  /**
   * Handle focus events to enlarge CSS editor textearea
   */
  toggleCssEdit = () => {
    this.setState(({ customCssEdit }) => ({ customCssEdit: !customCssEdit }))
  }

  /**
   * Handle focus events to enlarge JS editor textearea
   */
  toggleJsEdit = () => {
    this.setState(({ customJsEdit }) => ({ customJsEdit: !customJsEdit }))
  }

  /**
   * Submit form data to server if no validation errors are present
   */
  handleSubmit = () => {
    let {
      templateName,
      navBar,
      navBarText,
      navBarHoverBackground,
      navBarHoverText,
      navBarLogoPath,
      navBarLogoContainerBackground,
      navBarLogoContainerTopValue,
      navBarLogoContainerLeftValue,
      navBarLogoContainerWidthValue,
      navBarLogoContainerHeightValue,
      navBarLogoWidthValue,
      navBarLogoHeightValue,
      navBarLogoMarginValue,
      titlePageLogoPath,
      titlePageBackgroundImagePath,
      titlePageBackgroundColor,
      level1HeadingBackground,
      level1HeadingText,
      level2HeadingText,
      level3HeadingText,
      sectionNavMainColor,
      sectionNavHoverText,
      bootstrapPrimaryColor,
      bootstrapPrimaryHoverColor,
      customCss,
      customJs,
      submitted,
      serverError,
    } = this.state

    if (submitted && !serverError) return // Do not allow submitting more than once

    let formErrors = []

    let colorFields = [
      navBar,
      navBarText,
      navBarHoverBackground,
      navBarHoverText,
      navBarLogoContainerBackground,
      titlePageBackgroundColor,
      level1HeadingBackground,
      level1HeadingText,
      level2HeadingText,
      level3HeadingText,
      sectionNavMainColor,
      sectionNavHoverText,
      bootstrapPrimaryColor,
      bootstrapPrimaryHoverColor,
    ]

    for (var i = 0, len = colorFields.length; i < len; i++) {
      if (
        colorFields[i] !== '' &&
        colorFields[i].length !== 3 &&
        colorFields[i].length !== 6
      ) {
        formErrors.push('Color codes MUST be either 3 or 6 characters.')
      }
    }

    if (formErrors.length) {
      return this.setState({ formErrors })
    }

    let nextState = { submitted: true, formErrors: [] }

    let formData = {
      templateName: templateName,
      navBar: navBar,
      navBarText: navBarText,
      navBarHoverBackground: navBarHoverBackground,
      navBarHoverText: navBarHoverText,
      navBarLogoPath: navBarLogoPath,
      navBarLogoContainerBackground: navBarLogoContainerBackground,
      navBarLogoContainerTopValue: navBarLogoContainerTopValue,
      navBarLogoContainerLeftValue: navBarLogoContainerLeftValue,
      navBarLogoContainerWidthValue: navBarLogoContainerWidthValue,
      navBarLogoContainerHeightValue: navBarLogoContainerHeightValue,
      navBarLogoWidthValue: navBarLogoWidthValue,
      navBarLogoHeightValue: navBarLogoHeightValue,
      navBarLogoMarginValue: navBarLogoMarginValue,
      titlePageLogoPath: titlePageLogoPath,
      titlePageBackgroundImagePath: titlePageBackgroundImagePath,
      titlePageBackgroundColor: titlePageBackgroundColor,
      level1HeadingBackground: level1HeadingBackground,
      level1HeadingText: level1HeadingText,
      level2HeadingText: level2HeadingText,
      level3HeadingText: level3HeadingText,
      sectionNavMainColor: sectionNavMainColor,
      sectionNavHoverText: sectionNavHoverText,
      bootstrapPrimaryColor: bootstrapPrimaryColor,
      bootstrapPrimaryHoverColor: bootstrapPrimaryHoverColor,
      customCss: customCss,
      customJs: customJs,
    }
    client
      .post(endpoints.save({ id: OBJECT_ID }), formData)
      .then(() => {
        nextState.serverError = false
        nextState.feedback = ''
        this.setState(nextState)
      })
      .catch(e => {
        if (e.response.data.error) {
          nextState.serverError = true
          nextState.formErrors.push(e.response.data.error)
          this.setState(nextState)
        } else {
          nextState.serverError = true
          nextState.formErrors.push(
            'Oops! An error occurred submitting your form. Try again in a moment.'
          )
          this.setState(nextState)
        }
      })
  }

  renderServerMessage() {
    if (!this.state.submitted) return

    return (
      <div className="feedback-success">
        <h2 className="success-header pt-0 ml-4">Changes Saved!</h2>
        <p>
          If you want to make additional changes click here:
          <a onClick={this.resetForm} className="btn btn-myed btn-primary btn-primary-myed">
            More changes
          </a>
        </p>
      </div>
    )
  }

  render() {
    let {
      templateName,
      navBar,
      navBarText,
      navBarHoverBackground,
      navBarHoverText,
      navBarLogoPath,
      navBarLogoContainerBackground,
      navBarLogoContainerTopValue,
      navBarLogoContainerLeftValue,
      navBarLogoContainerWidthValue,
      navBarLogoContainerHeightValue,
      navBarLogoWidthValue,
      navBarLogoHeightValue,
      navBarLogoMarginValue,
      titlePageBackgroundImagePath,
      titlePageBackgroundColor,
      level1HeadingBackground,
      level1HeadingText,
      level2HeadingText,
      level3HeadingText,
      sectionNavMainColor,
      sectionNavHoverText,
      bootstrapPrimaryColor,
      bootstrapPrimaryHoverColor,
      customCss,
      customJs,
      submitted,
      serverError,
    } = this.state
    let successfulSubmit = submitted && !serverError

    let h1Styles = {}
    if (level1HeadingBackground)
      Object.assign(h1Styles, {
        backgroundColor: '#' + level1HeadingBackground,
      })
    if (level1HeadingText)
      Object.assign(h1Styles, { color: '#' + level1HeadingText })
    let h2Styles = level2HeadingText ? { color: '#' + level2HeadingText } : null
    let h3Styles = level3HeadingText ? { color: '#' + level3HeadingText } : null

    let toolbarStyles = {
      backgroundColor: '#fff',
      color: '#' + sectionNavMainColor,
    }
    let toolbarStylesActive = {
      backgroundColor: '#' + sectionNavMainColor,
      color: '#ffffff',
    }

    let bootstrapStyles = bootstrapPrimaryColor
      ? {
          backgroundColor: '#' + bootstrapPrimaryColor,
          borderColor: '#' + bootstrapPrimaryColor,
        }
      : null

    return (
      <div id="feedback-row" className="row">
        <section id="feedback-section">
          <div className="p-3 border bg-white">
            <div>
              {this.state.formErrors.map(msg => (
                <div key={msg} className="alert alert-danger">
                  {msg}
                </div>
              ))}
            </div>
            {this.renderServerMessage()}
            <form onSubmit={e => e.preventDefault()}>
              <div
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              >
                <label htmlFor="feedback">Template Name:&nbsp;</label>
                <input
                  type="text"
                  id="templateName"
                  name="templateName"
                  onChange={this.handleChange}
                  value={templateName}
                />
              </div>
              <hr
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              />
              <div
                className={classnames('flex-container', {
                  hidden: successfulSubmit,
                })}
              >
                <div className="input-container">
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">Navigation Bar:&nbsp;</label>
                    <input
                      type="text"
                      id="navBar"
                      name="navBar"
                      onChange={this.handleChange}
                      value={navBar}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + navBar }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">Navigation Bar Text:&nbsp;</label>
                    <input
                      type="text"
                      id="navBarText"
                      name="navBarText"
                      onChange={this.handleChange}
                      value={navBarText}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + navBarText }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Navigation Bar Hover Background:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarHoverBackground"
                      name="navBarHoverBackground"
                      onChange={this.handleChange}
                      value={navBarHoverBackground}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + navBarHoverBackground }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Navigation Bar Hover Text:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarHoverText"
                      name="navBarHoverText"
                      onChange={this.handleChange}
                      value={navBarHoverText}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + navBarHoverText }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Navigation Bar Logo Path:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoPath"
                      name="navBarLogoPath"
                      onChange={this.handleChange}
                      style={{ width: '400px' }}
                      value={navBarLogoPath}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoContainerBackground">
                      Navbar Logo Container Background:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoContainerBackground"
                      name="navBarLogoContainerBackground"
                      onChange={this.handleChange}
                      value={navBarLogoContainerBackground}
                    />
                    <div
                      className="color-preview"
                      style={{
                        backgroundColor: '#' + navBarLogoContainerBackground,
                      }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoContainerTopValue">
                      Navbar Logo Container Top Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoContainerTopValue"
                      name="navBarLogoContainerTopValue"
                      onChange={this.handleChange}
                      style={{ width: '50px' }}
                      value={navBarLogoContainerTopValue}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoContainerLeftValue">
                      Navbar Logo Container Left Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoContainerLeftValue"
                      name="navBarLogoContainerLeftValue"
                      onChange={this.handleChange}
                      style={{ width: '50px' }}
                      value={navBarLogoContainerLeftValue}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoContainerWidthValue">
                      Navbar Logo Container Width Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoContainerWidthValue"
                      name="navBarLogoContainerWidthValue"
                      onChange={this.handleChange}
                      style={{ width: '50px' }}
                      value={navBarLogoContainerWidthValue}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoContainerHeightValue">
                      Navbar Logo Container Height Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoContainerHeightValue"
                      name="navBarLogoContainerHeightValue"
                      onChange={this.handleChange}
                      style={{ width: '50px' }}
                      value={navBarLogoContainerHeightValue}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoWidthValue">
                      Navbar Logo Width Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoWidthValue"
                      name="navBarLogoWidthValue"
                      onChange={this.handleChange}
                      style={{ width: '50px' }}
                      value={navBarLogoWidthValue}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoHeightValue">
                      Navbar Logo Height Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoHeightValue"
                      name="navBarLogoHeightValue"
                      onChange={this.handleChange}
                      style={{ width: '50px' }}
                      value={navBarLogoHeightValue}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="navBarLogoMarginValue">
                      Navbar Logo Margin Value:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="navBarLogoMarginValue"
                      name="navBarLogoMarginValue"
                      onChange={this.handleChange}
                      style={{ width: '160px' }}
                      value={navBarLogoMarginValue}
                    />
                  </div>
                </div>
                <div className="preview-container" />
              </div>
              <hr
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              />
              <div
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              >
                <label htmlFor="feedback">
                  Title Page Background Image Path:&nbsp;
                </label>
                <input
                  type="text"
                  id="titlePageBackgroundImagePath"
                  name="titlePageBackgroundImagePath"
                  onChange={this.handleChange}
                  style={{ width: '400px' }}
                  value={titlePageBackgroundImagePath}
                />
              </div>
              <div
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              >
                <label htmlFor="feedback">
                  Title Page Background Color:&nbsp;
                </label>
                <input
                  type="text"
                  id="titlePageBackgroundColor"
                  name="titlePageBackgroundColor"
                  onChange={this.handleChange}
                  value={titlePageBackgroundColor}
                />
                <div
                  className="color-preview"
                  style={{ backgroundColor: '#' + titlePageBackgroundColor }}
                />
              </div>
              <hr className={classnames({ hidden: successfulSubmit })} />
              <div
                className={classnames('flex-container', {
                  hidden: successfulSubmit,
                })}
              >
                <div className="input-container">
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Level 1 Heading Background:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="level1HeadingBackground"
                      name="level1HeadingBackground"
                      onChange={this.handleChange}
                      value={level1HeadingBackground}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + level1HeadingBackground }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Level 1 Heading Text:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="level1HeadingText"
                      name="level1HeadingText"
                      onChange={this.handleChange}
                      value={level1HeadingText}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + level1HeadingText }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Level 2 Heading Text:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="level2HeadingText"
                      name="level2HeadingText"
                      onChange={this.handleChange}
                      value={level2HeadingText}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + level2HeadingText }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Level 3 Heading Text:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="level3HeadingText"
                      name="level3HeadingText"
                      onChange={this.handleChange}
                      value={level3HeadingText}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + level3HeadingText }}
                    />
                  </div>
                </div>
                <div className="preview-container">
                  <h1 style={h1Styles}>Level 1 Heading</h1>
                  <h2 style={h2Styles}>Level 2 Heading</h2>
                  <h3 style={h3Styles}>Level 3 Heading</h3>
                </div>
              </div>
              <hr
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              />
              <div
                className={classnames('flex-container', {
                  hidden: successfulSubmit,
                })}
              >
                <div className="input-container">
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Section Navigation Main Color:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="sectionNavMainColor"
                      name="sectionNavMainColor"
                      onChange={this.handleChange}
                      value={sectionNavMainColor}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + sectionNavMainColor }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="feedback">
                      Section Navigation Hover Text:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="sectionNavHoverText"
                      name="sectionNavHoverText"
                      onChange={this.handleChange}
                      value={sectionNavHoverText}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + sectionNavHoverText }}
                    />
                  </div>
                </div>
                <div className="preview-container">
                  <ul id="toolbar_item_list" className="nav nav-list">
                    <li className="toolbar_item active">
                      <a
                        className="toolbar_item_link"
                        style={toolbarStylesActive}
                      >
                        <div className="toolbar_item_row clearfix">
                          <div className="section_completion_icon icon icon_checkmark3" />
                          <div className="toolbar_item_title">
                            Section title
                          </div>
                        </div>
                        <div style={{ height: '2px' }} />
                        <div className="toolbar_item_detail_row clearfix">
                          <div className="detail_completion_icon progress_icon icon icon_checkmark3" />
                          <div
                            className="detail_completion_percentage"
                            data-toggle="tooltip"
                            data-placement="auto"
                          >
                            <span className="badge">15 / 15</span>
                          </div>
                          <div className="detail_completion_title">Reading</div>
                        </div>
                      </a>
                    </li>
                    <li className="toolbar_item">
                      <a className="toolbar_item_link" style={toolbarStyles}>
                        <div className="toolbar_item_row clearfix">
                          <div className="section_completion_icon icon icon_checkmark3" />
                          <div className="toolbar_item_title">
                            Section 2 title
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="toolbar_item ">
                      <a className="toolbar_item_link" style={toolbarStyles}>
                        <div className="toolbar_item_row clearfix">
                          <div className="section_completion_icon icon icon_checkmark3" />
                          <div className="toolbar_item_title">
                            Section 3 title
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className={classnames({ hidden: successfulSubmit })} />
              <div
                className={classnames('flex-container', {
                  hidden: successfulSubmit,
                })}
              >
                <div className="input-container">
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="bootstrapPrimaryColor">
                      Bootstrap Primary Color:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="bootstrapPrimaryColor"
                      name="bootstrapPrimaryColor"
                      onChange={this.handleChange}
                      value={bootstrapPrimaryColor}
                    />
                    <div
                      className="color-preview"
                      style={{ backgroundColor: '#' + bootstrapPrimaryColor }}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="bootstrapPrimaryHoverColor">
                      Bootstrap Primary Hover Color:&nbsp;
                    </label>
                    <input
                      type="text"
                      id="bootstrapPrimaryHoverColor"
                      name="bootstrapPrimaryHoverColor"
                      onChange={this.handleChange}
                      value={bootstrapPrimaryHoverColor}
                    />
                    <div
                      className="color-preview"
                      style={{
                        backgroundColor: '#' + bootstrapPrimaryHoverColor,
                      }}
                    />
                  </div>
                </div>
                <div className="preview-container">
                  <button
                    className={classnames('btn', 'btn-primary')}
                    style={bootstrapStyles}
                  >
                    Primary Button
                  </button>
                  <div className="progress_container">
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-primary"
                        style={bootstrapStyles}
                      >
                        70%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr
                className={classnames('field-group', {
                  hidden: successfulSubmit,
                })}
              />
              <div
                className={classnames('flex-container', {
                  hidden: successfulSubmit,
                })}
              >
                <div className="input-container">
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="customCss">Custom CSS:&nbsp;</label>
                    <textarea
                      id="customCss"
                      name="customCss"
                      className={this.state.customCssEdit ? 'editor' : null}
                      onFocus={this.toggleCssEdit}
                      onBlur={this.toggleCssEdit}
                      onChange={this.handleChange}
                      value={customCss}
                    />
                  </div>
                  <div
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  >
                    <label htmlFor="customJs">Custom JS:&nbsp;</label>
                    <textarea
                      id="customJs"
                      name="customJs"
                      className={this.state.customJsEdit ? 'editor' : null}
                      onFocus={this.toggleJsEdit}
                      onBlur={this.toggleJsEdit}
                      onChange={this.handleChange}
                      value={customJs}
                    />
                  </div>
                  <hr
                    className={classnames('field-group', {
                      hidden: successfulSubmit,
                    })}
                  />
                  <div className="field-group">
                    <button
                      onClick={this.handleSubmit}
                      className={classnames('btn', 'btn-primary', {
                        hidden: successfulSubmit,
                      })}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="preview-container" />
              </div>
            </form>
          </div>
        </section>
      </div>
    )
  }
}

export const startCustomCssApp = () => {
  const root = createRoot(document.getElementById('custom-css-app'))
  root.render(<Application />)
}
